import React from 'react';
import Sketches from '..';
import APlanHeader from '../../../components/templates/aplan-header';
import MainLayout from '../../layouts/main-layout';

export default function SketchesWithHeader() {
  return (
    <MainLayout header={<APlanHeader />}>
      <Sketches />
    </MainLayout>
  );
}
